import React, { useMemo } from 'react';
import {
  Flex,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  Space,
  Submenu,
  SubmenuToggle,
  SubmenuList,
} from '@tonic-one/react';
import { AngleRightIcon } from '@tonic-one/react-icons';
import { useTranslation } from 'react-i18next';
import { usePermissionStore } from '@Models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';

function AddButton({
  orgId,
  handleClickMenuItem,
  apiDataList,
}: {
  orgId: string;
  handleClickMenuItem: (value: any) => void;
  apiDataList: any;
}) {
  const { t } = useTranslation('common');
  const accounts = [{ key: 1 }, { key: 100 }];
  const { widthEditablePermission } = usePermissionStore();
  const trendMicroServices = [{ key: 102 }];
  const addDisabled = useMemo(() => {
    let index = 0;
    if (apiDataList) {
      apiDataList.map((item: any) => {
        if (item.category === 102) index++;
      });
    }
    return index !== 0;
  }, [apiDataList]);
  return (
    <Flex direction="row" display="inline-flex" align="center">
      <Menu>
        <MenuButton
          variant="primary"
          borderTopLeftRadius="0"
          borderBottomLeftRadius="0"
          disabled={
            (apiDataList && apiDataList.length >= 20) ||
            !widthEditablePermission(PermissionNameEnum.administrator)
          }
        >
          {t('common.action.label.add')}
          <Space width="16px" />
        </MenuButton>
        <MenuList
          width="max-content"
          onClick={(e) => {
            handleClickMenuItem({
              value: (e.target as HTMLDivElement).getAttribute('value'),
              id: orgId,
            });
          }}
        >
          {accounts.map((item) => {
            const v = item.key;
            if (!v) {
              return <></>;
            }
            if (v === 1) {
              return (
                <MenuItem value={v} key={v}>
                  {t(`administration.apiToken.add.tokenName.${v}`)}
                </MenuItem>
              );
            } else {
              return (
                <Submenu placement="right-start" key={v}>
                  <SubmenuToggle width="100%">
                    <MenuItem>
                      <Flex
                        alignItems="center"
                        columnGap="2x"
                        justifyContent="space-between"
                        width="100%"
                      >
                        {t(`administration.apiToken.add.tokenName.${v}`)}
                        <Icon as={AngleRightIcon} />
                      </Flex>
                    </MenuItem>
                  </SubmenuToggle>
                  <SubmenuList width="max-content">
                    {trendMicroServices.map((subItem) => {
                      return (
                        <MenuItem
                          value={subItem.key}
                          key={subItem.key}
                          disabled={addDisabled}
                        >
                          {t(
                            `administration.apiToken.add.tokenName.${subItem.key}`
                          )}
                        </MenuItem>
                      );
                    })}
                  </SubmenuList>
                </Submenu>
              );
            }
          })}
        </MenuList>
      </Menu>
    </Flex>
  );
}

export default AddButton;
